import { render, staticRenderFns } from "./edit-drawer.vue?vue&type=template&id=89378c8a"
import script from "./edit-drawer.vue?vue&type=script&lang=js"
export * from "./edit-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports